const updateArrayAfterDrag = (newArray, sourceArr, key) => {
    const orderMap = newArray.reduce((map, item, index) => {
        map[item.key] = index;
        return map;
    }, {});
    
    let newArr = [...sourceArr].sort((a, b) => {
        const orderA = orderMap[a[key]] !== undefined ? orderMap[a[key]] : Number.MAX_SAFE_INTEGER;
        const orderB = orderMap[b[key]] !== undefined ? orderMap[b[key]] : Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
    });
    return newArr;
};
export default  updateArrayAfterDrag;